import TableCell from './TableCell'
import TableCellRenderer from './TableCellRenderer'
import _ from 'underscore'
import $ from 'jquery'

function TableRow(rowEl)
{
    this.cells = [];
    this.rowEl = rowEl ? rowEl : document.createElement("tr");
    this.table = null;
    this.rowIdx = -1;
}

TableRow.prototype = _.create(Object.prototype, {
    setRowIdx: function(rowIdx)
    {
        this.rowIdx = rowIdx;
    },

    getRowIdx: function()
    {
        return this.rowIdx;
    },

    createCellObj: function(value)
    {
        return new TableCell(value, this);
    },

    createCellObjAndAdd: function(value)
    {
        var cellObj = this.createCellObj(value);
        this.addCellObj(cellObj);
        return cellObj;
    },

    addCell: function(value)
    {
        var cellObj = this.createCellObjAndAdd(value);
        cellObj.setupMouseHandlers();
    },

    addCellObj: function(cellObj)
    {
        cellObj.setRow(this);
        cellObj.setColIdx(this.cells.length);
        this.cells.push(cellObj);
        this.getRowEl().appendChild(cellObj.getCellEl());

        if (cellObj.colspan)
            $(cellObj.getCellEl()).attr('colspan', cellObj.colspan);
    },

    setTable: function(table)
    {
        this.table = table;
    },

    getTable: function()
    {
        return this.table;
    },

    getRowEl: function()
    {
        return this.rowEl;
    },

    getCells: function()
    {
        return this.cells;
    },

    getCell: function(colIdx)
    {
        return this.cells[colIdx];
    },

    getLastCell: function()
    {
        return this.cells[this.cells.length - 1];
    },

    hasCell: function(colIdx)
    {
        return this.cells.length > colIdx;
    },

    writeCellsContent: function()
    {
        for (var i = 0; i < this.cells.length; i++)
        {
            var cell = this.cells[i];
            cell.setRenderer(this.createCellRenderer(cell));
            cell.writeContent();
        }
    },

    showHide: function(isShow)
    {
        this.getRowEl().style.display = isShow ? "" : "none";
    },

    updateUI: function()
    {
    },

    createCellRenderer: function(cell)
    {
        return new TableCellRenderer();
    },

    updateCellUI: function(colIdx)
    {
        this.getCell(colIdx).updateUI();
    },

    buildDOM: function(parentEl)
    {
        parentEl.appendChild(this.getRowEl());
    },

    accept: function(visitor, cell)
    {
        if (visitor.visitOtherRow)
            visitor.visitOtherRow(cell);
    },

    isLast: function()
    {
        return this.rowIdx == this.table.getRows().length - 1;
    },

    getRowClasses: function()
    {
        return [];
    }
});

export default TableRow



// WEBPACK FOOTER //
// ./web/js/table/TableRow.js